export type FuseIconProps = React.HTMLProps<HTMLImageElement>;

export const FuseIcon: React.FC<FuseIconProps> = (props) => (
  <img alt="Fuse Icon" src={new URL('/public/images/brand/fuse-icon.png', import.meta.url).toString()} {...props} />
);
